module.exports = "https://cdn.realtymogul.com/static/media/img_location_la.bf19fcd5.jpg";